import { EventEmitter } from 'eventemitter3';
import { createDoneEncodedAudioFrame, encodedAudioFrameToAudioFrame, } from '../streamrapp/types/EncodedAudioFrame';
import { createDoneEncodedVideoFrame } from '../streamrapp/types/EncodedVideoFrame';
import { MediaPacketFragmenter } from './MediaPacketFragmenter';
export class MediaPacketizer extends EventEmitter {
    mediaPacketFragmenter;
    audioFrameBuffer = [];
    mediaPacketCounter = 0;
    isVideoActive = false;
    audioCodec;
    separateAudioPackets;
    currentAudioLevel;
    currentIsSpeaking;
    constructor(options) {
        super();
        this.mediaPacketFragmenter = new MediaPacketFragmenter();
        this.audioFrameBuffer = [];
        this.audioCodec = options.audioCodec;
        this.separateAudioPackets = options.separateAudioPackets ?? false;
    }
    addVideoFrame(videoFrame, mediaStreamId) {
        const audioFrames = this.separateAudioPackets
            ? []
            : this.audioFrameBuffer;
        const mediaPacket = {
            packetNumber: BigInt(this.mediaPacketCounter++),
            videoFrames: [videoFrame],
            audioFrames,
            ...(audioFrames.length > 0 && { audioCodec: this.audioCodec }),
            mediaStreamId,
            endedTracks: [],
            ...this.getSpeechFields(),
        };
        if (!this.separateAudioPackets) {
            this.audioFrameBuffer = [];
        }
        const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
        for (const fragment of fragments) {
            this.emit('mediaPacketFragment', fragment);
        }
    }
    addAudioFrames(audioFrames, mediaStreamId) {
        if (this.separateAudioPackets || !this.isVideoActive) {
            const mediaPacket = {
                packetNumber: BigInt(this.mediaPacketCounter++),
                audioCodec: this.audioCodec,
                videoFrames: [],
                audioFrames: audioFrames,
                mediaStreamId,
                endedTracks: [],
                ...this.getSpeechFields(),
            };
            const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
            for (const fragment of fragments) {
                this.emit('mediaPacketFragment', fragment);
            }
        }
        else {
            this.audioFrameBuffer.push(...audioFrames);
        }
    }
    setSpeechState(isSpeaking, audioLevel) {
        this.currentIsSpeaking = isSpeaking;
        this.currentAudioLevel = audioLevel;
    }
    getSpeechFields() {
        return {
            ...(this.currentAudioLevel !== undefined && {
                audioLevel: this.currentAudioLevel,
            }),
            ...(this.currentIsSpeaking !== undefined && {
                isSpeaking: this.currentIsSpeaking,
            }),
        };
    }
    setIsVideoActive(isVideoActive) {
        console.log('setIsVideoActive', isVideoActive);
        this.isVideoActive = isVideoActive;
    }
    sendDoneVideoFrame(trackId, frameNumber, mediaStreamId) {
        this.addVideoFrame(createDoneEncodedVideoFrame(trackId, frameNumber), mediaStreamId);
        this.flush(mediaStreamId);
    }
    sendDoneAudioFrame(trackId, frameNumber, mediaStreamId) {
        const doneFrame = createDoneEncodedAudioFrame(trackId, frameNumber);
        this.addAudioFrames([encodedAudioFrameToAudioFrame(doneFrame)], mediaStreamId);
        this.flush(mediaStreamId);
    }
    flush(mediaStreamId) {
        if (this.audioFrameBuffer.length === 0) {
            return;
        }
        const mediaPacket = {
            packetNumber: BigInt(this.mediaPacketCounter++),
            audioCodec: this.audioCodec,
            videoFrames: [],
            audioFrames: this.audioFrameBuffer,
            mediaStreamId,
            endedTracks: [],
            ...this.getSpeechFields(),
        };
        this.audioFrameBuffer = [];
        const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
        for (const fragment of fragments) {
            this.emit('mediaPacketFragment', fragment);
        }
        console.log('Flushed buffered audio frames');
    }
}
